// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".u8-rank-item {\n  font-size: 14px;\n  padding: 0 20px 20px 20px;\n}\n.u8-rank-item .u8-rank-item__header--title {\n  color: #606266;\n}\n.u8-rank-item .u8-rank-item__header--value {\n  color: #606266;\n}", ""]);
// Exports
module.exports = exports;
